import { render, staticRenderFns } from "./CampanhaIcone.vue?vue&type=template&id=144673a6"
import script from "./CampanhaIcone.vue?vue&type=script&lang=js"
export * from "./CampanhaIcone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports